<template>
  <content-dialog
    :visible.sync="modalVisible"
    persistent
    max-width="1000px"
  >
    <template slot="dialogTitle">
      Edit {{ yachtEquipmentPackIds.length }} selected equipment packs
    </template>

    <v-card-text :class="{'px-5 pt-6 pb-12': !$vuetify.breakpoint.xsOnly }">
      <validation-observer ref="validationObserver">
        <v-subheader>
          Status
        </v-subheader>
        <v-btn-toggle
          v-model="data.status"
          color="primary"
        >
          <v-btn
            value="draft"
            large
          >
            Draft
          </v-btn>
          <v-btn
            value="active"
            large
          >
            Active
          </v-btn>
          <v-btn
            value="discarded"
            large
          >
            Discarded
          </v-btn>
        </v-btn-toggle>

        <!--<editor-fold desc="Installation">-->
        <v-subheader>
          Installed By
        </v-subheader>
        <v-btn-toggle
          v-model="data.installed_by"
          color="primary"
        >
          <v-btn
            value="shipyard"
            large
          >
            Shipyard
          </v-btn>
          <v-btn
            value="contractor"
            large
          >
            C. Yard
          </v-btn>
          <v-btn
            value="navigare"
            large
          >
            Navigare Base
          </v-btn>
        </v-btn-toggle>
        <!--</editor-fold>-->

        <v-subheader class="mt-6">
          Equipment Category
        </v-subheader>

        <validation-provider
          name="Category"
        >
          <v-autocomplete
            v-model="data.category_id"
            :items="categories.data"
            :loading="categories.loading"
            name="category"
            label="Select Category"
            item-value="id"
            item-text="name"
            hide-details
            clearable
            autocomplete="off"
            outlined
          />
        </validation-provider>

        <!--<editor-fold desc="Applicable Yacht Models">-->
        <v-subheader class="mt-6">
          Applicable Yacht Models
        </v-subheader>

        <yacht-model-select
          v-model="data.models"
          :items="yachtModels.data"
          :loading="yachtModels.loading"
          name="models"
          label="Select Yacht Models"
          item-text="full_label"
          item-value="id"
          return-object
          outlined
          chips
          deletable-chips
          single-line
          small-chips
          multiple
          :hide-details="data.models.length > 0"
        />

        <div
          v-show="data.models.length > 0"
          class="mb-6 mt-4"
        >
          <template v-for="yachtModel in data.models">
            <v-row
              :key="yachtModel.id"
              dense
              no-gutters
              align="center"
              class="list--bordered py-2"
            >
              <v-col
                cols="auto"
              >
                <v-icon
                  color="red"
                  @click="removeSelectedYachtModel(yachtModel.id)"
                >
                  close
                </v-icon>
              </v-col>
              <v-col
                class="subtitle-1 grow"
              >
                {{ yachtModel.label }}
              </v-col>
              <v-col
                class="grey--text caption mr-4"
                cols="auto"
              >
                add by default
              </v-col>
              <v-col cols="auto">
                <v-switch
                  v-model="yachtModel.default"
                  hide-details
                  class="ma-0 pa-0"
                />
              </v-col>
            </v-row>
          </template>
        </div>
        <!--</editor-fold>-->

        <!--<editor-fold desc="Applicable Countries">-->
        <v-subheader>
          Applicable Countries
        </v-subheader>

        <v-autocomplete
          v-model="data.country_ids"
          :items="countries.data"
          :loading="countries.loading"
          label="Select Countries"
          item-value="id"
          item-text="name"
          autocomplete="off"
          single-line
          outlined
          small-chips
          deletable-chips
          multiple
        />
        <!--</editor-fold>-->

        <!--<editor-fold desc="Supplier">-->
        <v-subheader>
          Equipment Supplier
        </v-subheader>
        <v-autocomplete
          v-model="data.supplier_id"
          outlined
          label="Select supplier"
          clearable
          :items="suppliers.data"
          item-text="name"
          item-value="id"
          :loading="suppliers.loading"
        />
        <!--</editor-fold>-->

        <v-subheader>
          Offer Visibility Settings
        </v-subheader>

        <v-checkbox
          v-model="data.offer_visible"
          label="Pack listed"
          class="ma-0"
        />

        <v-checkbox
          v-model="data.offer_items_visible"
          label="Pack's items listed"
          class="ma-0"
        />
      </validation-observer>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
import YachtModel from '@/models/YachtModel'
import YachtEquipmentPackCategory from '@/models/YachtEquipmentPackCategory'
import Contractor from '@/models/Contractor'
import ContentDialog from '@/components/helpers/Dialog'
import validationScrollMixin from '@/mixins/validationScrollMixin'
import YachtModelSelect from '@/components/helpers/YachtModelSelect'
import YachtEquipmentPack from '@/models/YachtEquipmentPack'

export default {
    name: 'YachtEquipmentPackMassEditDialog',
    components: {
      YachtModelSelect,
      ContentDialog
    },
    mixins: [validationScrollMixin],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      yachtEquipmentPackIds: {
        type: Array,
        default: () => ([])
      }
    },
    data() {
      return {
        data: {
          installed_by: undefined,
          status: undefined,
          models: [],
          country_ids: [],
          category_id: undefined,
          supplier_id: undefined,
          offer_visible: true,
          offer_items_visible: true,
          offer_visible_sale_price: false,
          offer_items_visible_sale_price: false
        },
        yachtModels: {
          data: [],
          loading: false
        },
        contractors: {
          data: [],
          loading: false
        },
        suppliers: {
          data: [],
          loading: false
        },
        // categories: {
        //   data: [],
        //   loading: false
        // },
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      countries() {
        return this.$store.getters['settings/charteringCountries']
      },
      categories() {
        return this.$store.getters['settings/equipmentPackCategories']
      }
    },
    watch: {
      modalVisible() {
        if (!this.visible) return

        this.data = {
          installed_by: undefined,
          status: undefined,
          models: [],
          country_ids: [],
          category_id: undefined,
          supplier_id: undefined,
          offer_visible: true,
          offer_items_visible: true,
          offer_visible_sale_price: false,
          offer_items_visible_sale_price: false
        }
      }
    },
  created() {
      this.init()
    },
    methods: {
      init() {
        this.fetchContractors()
        this.fetchSuppliers()
        this.fetchYachtModels()
      },
      async submit() {
        let validate = await this.$refs.validationObserver.validate()

        if (!validate) {
          this.showAlertAndScrollToFirstError()
          return
        }

        this.save()
      },
      async save() {
        this.submitting = true

        try {
          this.submitting = true

          const data = {
            yacht_equipment_pack_ids: this.yachtEquipmentPackIds,
            installed_by: this.data.installed_by,
            status: this.data.status,
            yacht_models: this.data.models.length > 0 ? this.data.models.map(m => {
              return {
                yacht_model_id: m.id,
                default: !!m.default
              }
            }) : undefined,
            country_ids: this.data.country_ids.length > 0 ? this.data.country_ids : undefined,
            yacht_equipment_pack_category_id: this.data.category_id,
            supplier_id: this.data.supplier_id,
            offer_visible: this.data.offer_visible,
            offer_items_visible: this.data.offer_items_visible,
            offer_visible_sale_price: this.data.offer_visible_sale_price,
            offer_items_visible_sale_price: this.data.offer_items_visible_sale_price
          }

          const result = await YachtEquipmentPack.api.massEdit(data)

          this.$emit('edited')

          if (result.not_activated_count > 0) {
            this.$store.dispatch('alert', {
              text: `Successfully edited ${this.yachtEquipmentPackIds.length} equipment packs. ${result.not_activated_count} could not have been activated since required detilas are missing.`,
              color: 'orange darken-1'
            })
          } else {
            this.$store.dispatch('alert', {
              text: 'Successfully edited ' + this.yachtEquipmentPackIds.length + ' equipment packs',
              color: 'success'
            })
          }

          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            text: 'There was an error submitting data',
            color: 'error'
          })
        } finally {
          this.submitting = false
        }
      },
      async deleteYachtEquipmentPack() {
      },
      async fetchYachtModels() {
        this.yachtModels.loading = true

        try {
          this.yachtModels.data = await YachtModel.api.fetch({
            status: YachtModel.STATUS_ACTIVE,
            is_sales_active: true
          })
        } catch (e) {
          throw e
        } finally {
          this.yachtModels.loading = false
        }
      },
      async fetchCategories() {
        this.categories.loading = true

        try {
          this.categories.data = await YachtEquipmentPackCategory.api.fetch()
        } catch (e) {
          throw e
        } finally {
          this.categories.loading = false
        }
      },
      async fetchContractors() {
        this.contractors.loading = true

        try {
          this.contractors.data = await Contractor.api.fetch({ type: Contractor.TYPE_YARD })
        } catch (e) {
          throw e
        } finally {
          this.contractors.loading = false
        }
      },
      async fetchSuppliers() {
        this.suppliers.loading = true

        try {
          this.suppliers.data = await Contractor.api.fetch({ type: Contractor.TYPE_SUPPLIER })
        } catch (e) {
          throw e
        } finally {
          this.suppliers.loading = false
        }
      },
      removeSelectedYachtModel(id) {
        this.yachtEquipmentPackDirty.models.splice(this.yachtEquipmentPackDirty.models.findIndex(model => id === model.id), 1)
      }
    }
  }
</script>
